import React, { Component } from 'react'
import {
    Container,
} from 'reactstrap'

import Breadcrumbs from '../../components/Common/Breadcrumb'
import DataTable from './components/DetailDatatable'

class Dashboard extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs
                            title="Pedidos"
                            breadcrumbItem={`Pedidos detalle`}
                            parentLink={`/pedidos`}
                        />
                        <DataTable />
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default Dashboard
